import { action, observable, computed, toJS } from 'mobx'
import fetch from 'isomorphic-unfetch'
import moment from 'moment'
import {withRouter} from 'react-router-dom'
import route from './fetchconfig.json'

export default class AdminStore {
 @observable loginname = ""
 @observable password = ""
 @observable users = []
 @observable settings = new Settings({})
 @observable wpSettings = new WPSettings({})
 @observable impressum = new Impressum({})
 @observable createdUserLoginname = ""
 @observable createdUserPassword = ""
 @observable inbox = new Inbox()
 @observable beispieltypen = new Beispieltypen()

 @observable exampleForm
 @observable collectionForm
 @observable hasMetaData = false

 constructor () {
   this.exampleForm = {
     asDeleteRestore:false,
     asUpdate:false,
     asAcceptDecline:true,
     currentExample:null
   }
   this.collectionForm = {
     asDeleteRestore:false,
     asAcceptDecline:true,
     currentCollection:null
   }
 }

 @action.bound setCollectionFormAsAcceptDecline() {
   this.collectionForm.asAcceptDecline = true
   this.collectionForm.asDeleteRestore = false
 }

 @action.bound setCollectionFormAsDeleteRestore () {
   this.collectionForm.asAcceptDecline = false
   this.collectionForm.asDeleteRestore = true
 }

 @action.bound setCurrentCollection (collection) {
   this.collectionForm.currentCollection = collection
 }

 @action.bound setExampleFormAsAcceptDecline() {
   this.exampleForm.asAcceptDecline = true
   this.exampleForm.asDeleteRestore = false
   this.exampleForm.asUpdate = false
 }

 @action.bound setExampleFormAsDeleteRestore () {
   this.exampleForm.asAcceptDecline = false
   this.exampleForm.asUpdate = false
   this.exampleForm.asDeleteRestore = true
 }

 @action.bound setExampleFormAsUpdate () {
   this.exampleForm.asAcceptDecline = false
   this.exampleForm.asUpdate = true
   this.exampleForm.asDeleteRestore = false
 }

 @action.bound setCurrentExample (example) {
   this.exampleForm.currentExample = example
 }

 @action.bound setCreatedUserPassword (password) {
   this.createdUserPassword = password
 }

 @action.bound setCreatedUserLoginname (loginname) {
   this.createdUserLoginname = loginname
 }

 @action.bound setPassword (password) {
   this.password = password
 }

 @action.bound setLoginname (loginname) {
   this.loginname = loginname
 }

 @action.bound logout (history,cookies) {
  cookies.remove('token')
  history.push(route.endpoint + '/admin')
 }

 @action.bound setUsers (users) {
   this.users = users.map((user) => {
     return new User(user)
   })
 }

 @action.bound setSettings (settings) {
   this.settings = new Settings(settings)
 }

 @action.bound setBeispieltypen (beispieltypen) {
   this.beispieltypen = new Beispieltypen(beispieltypen)
 }

 @action.bound setWPSettings (wpSettings) {
   this.wpSettings = new WPSettings(wpSettings)
 }

 @action.bound setImpressum (impressum) {
   this.impressum = new Impressum(impressum)
 }

 @action.bound getSettings () {
   fetch(route.endpoint + '/api/settings', {
     method: 'GET',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.setSettings(responseJson)
   })
   .catch((error) => {
     console.error(error);
   })
 }

 @action.bound getWPSettings () {
   fetch(route.endpoint + '/api/wpsettings', {
     method: 'GET',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.setWPSettings(responseJson)
   })
   .catch((error) => {
     console.error(error);
   })
 }

 @action.bound getImpressum () {
   fetch(route.endpoint + '/api/impressum', {
     method: 'GET',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.setImpressum(responseJson)
   })
   .catch((error) => {
     console.error(error);
   })
 }

 @action.bound getBeispieltypen () {
   fetch(route.endpoint + '/api/beispieltypen', {
     method: 'GET',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.setBeispieltypen(responseJson)
   })
   .catch((error) => {
     console.error(error);
   })
 }

 @action.bound getUsers () {
   fetch(route.endpoint + '/api/users', {
     method: 'GET',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.setUsers(responseJson)
   })
   .catch((error) => {
     console.error(error);
   })
 }

 @action verifyToken (token,cb) {
   fetch(route.endpoint + '/api/token/verify?token='+token,{
     method:'GET',
     credentials: "same-origin"
   })
   .then((response) => response.json())
   .then((responseJson) => {
    if (cb) cb(responseJson)
   })
 }

 @action.bound login (history,cookies) {
   if (this.loginname !== '' && this.password !== '') {
     fetch(route.endpoint + '/admin', {
       method: 'POST',
       credentials: "same-origin",
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
       },
       body: JSON.stringify({loginname:this.loginname,password:this.password})
     })
     .then((response) => response.json())
     .then((responseJson) => {
       if (responseJson.success) {
        if (document) {
          if (responseJson.token) {
            cookies.set('token',responseJson.token)
          }
          this.setPassword("")
          history.push(route.endpoint + '/admin/inbox')
        }
       }
     })
     .catch((error) => {
       console.error(error);
     })
   }
 }

 @action deleteUser (id,cb) {
   fetch(route.endpoint + '/api/user/delete', {
     method: 'POST',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
     body: JSON.stringify({id:id})
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.users = this.users.filter( (user) => {
       if (user.id !== id) {
         return user
       }
     })
     cb(responseJson.success)
   })
 }

 @action createUser (cb) {
   fetch(route.endpoint + '/api/user/create', {
     method: 'POST',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
     body: JSON.stringify(
      {login:this.createdUserLoginname,password:this.createdUserPassword}
     )
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.users.push(new User(responseJson.user))
     cb(responseJson.success)
   })
 }

}

class Inbox {
  @observable mails = []
  @observable trash = []
  @observable deadlinks = []

  INBOX_TYPE_EXAMPLE = 1
  INBOX_TYPE_COLLECTION = 2

  @computed get hasMail () {
    return this.mails.length > 0
  }

  @computed get hasTrash () {
    return this.trash.length > 0
  }

  @computed get hasDeadlinks () {
    return this.deadlinks.length > 0
  }

  @action removeDeadlink (itemId) {
    this.deadlinks = this.deadlinks.filter(item => item.id !== itemId)
  }

  @action removeItem (itemId,type) {
    this.mails = this.mails.filter( (currItem) => {
      if (currItem.id !== itemId) {
        if (currItem.isExample) {
          return type !== this.INBOX_TYPE_COLLECTION
        }
        else if (currItem.isCollection) {
          return type !== this.INBOX_TYPE_EXAMPLE
        }
      }
    })

    this.trash = this.trash.filter( (currItem) => {
      if (currItem.id !== itemId) {
        if (currItem.isExample) {
          return type !== this.INBOX_TYPE_COLLECTION
        }
        else if (currItem.isCollection) {
          return type !== this.INBOX_TYPE_EXAMPLE
        }
      }
    })

  }

  @action.bound getInbox (cb) {
    fetch(route.endpoint + '/api/inbox', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((inbox) => {
      this.setInbox(inbox)
    })
  }

  sortByCreated (arr) {
    return arr.sort( (a,b) => { return a.created > b.created })
  }

  @action setInbox (inbox) {
    this.mails = this.modifyTimestamp(inbox.mails)
    this.trash = this.modifyTimestamp(inbox.trash)
    if (inbox.deadlinks) {
     this.deadlinks = inbox.deadlinks
    }
  }

  @action modifyTimestamp (arr) {
    return arr.map( item => {
      if (item.created) {
       item.created = moment(item.created).fromNow()
      }
      return item
    })
  }

  @action.bound deleteItemPerm (id,cb) {
    fetch(route.endpoint + '/api/item/delete/perm?id='+id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(id,this.INBOX_TYPE_EXAMPLE)
     }
     cb(res)
    })
  }

  @action.bound restoreItem (id,cb) {
    fetch(route.endpoint + '/api/item/restore?id='+id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(id,this.INBOX_TYPE_EXAMPLE)
     }
     cb(res)
    })
  }

  @action.bound deleteCollectionPerm (id,cb) {
    fetch(route.endpoint + '/api/collection/delete/perm?id='+id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(id,this.INBOX_TYPE_COLLECTION)
     }
     cb(res)
    })
  }

  @action.bound restoreCollection (id,cb) {
    fetch(route.endpoint + '/api/collection/restore?id='+id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(id,this.INBOX_TYPE_COLLECTION)
     }
     cb(res)
    })
  }

  @action.bound acceptCollection (payload,cb) {
    fetch(route.endpoint + '/api/collection/accept', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(payload)
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(payload.id,this.INBOX_TYPE_COLLECTION)
     }
     cb(res)
    })
  }

  @action.bound declineCollection (id,cb) {
    fetch(route.endpoint + '/api/collection/decline?id='+id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(id,this.INBOX_TYPE_COLLECTION)
     }
     cb(res)
    })
  }

  @action.bound updateDeadlink (payload,cb) {
    payload.deadlink = 0
    fetch(route.endpoint + '/api/item/update', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(payload)
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeDeadlink(payload.id)
     }
     cb(res)
    })
  }

  @action.bound acceptExample (payload,cb) {
    fetch(route.endpoint + '/api/item/accept', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(payload)
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(payload.id,this.INBOX_TYPE_EXAMPLE)
     }
     cb(res)
    })
  }

  @action.bound declineExample (id,cb) {
    fetch(route.endpoint + '/api/item/decline?id='+id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((res) => {
     if (res.success) {
      this.removeItem(id,this.INBOX_TYPE_EXAMPLE)
     }
     cb(res)
    })
  }

}

class Beispieltypen {
  COLLECTION_TYPE_ID = 1
  @observable types

  constructor (beispieltypen) {
    this.types = beispieltypen ? beispieltypen : []
  }

  @action.bound updateIdsAfterServersideInsert (insertedItems) {
    this.types = this.types.map(type => {
      insertedItems.map(item => {
        if (item && item.id && item.name) {
          if (type.name === item.name) {
           type.id = item.id
          }
        }
      })
      return type
    })
  }

  @action.bound addEmptyType () {
    this.types.push({
      name:'',
      deleted:0,
      id:'create-new-'+Math.random()*Math.random()
    })
  }

  @action.bound changeName (id,newName) {
    this.types.map(type => {
      if (type.id === id) {
        type.name = newName
      }
    })
  }

  @action.bound changeDeletedState (id,cb) {
    this.types.map(type => {
      if (type.id === id) {
        type.deleted = !type.deleted
      }
    })
  }

  getExampletypes () {
    return this.types.filter(type => type.id !== this.COLLECTION_TYPE_ID)
  }

  getCollectionType () {
    const collectionTypeArray = this.types.filter(type => {if(type.id === this.COLLECTION_TYPE_ID) return type})
    if (collectionTypeArray && collectionTypeArray.length === 1) {
      return collectionTypeArray[0]
    }
    return {name:''}
  }

  @action.bound saveTypes (cb) {
    fetch(route.endpoint + '/api/beispieltypen/update', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.types)
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (cb) {
       if (responseJson.insertedItems) {
        this.updateIdsAfterServersideInsert(responseJson.insertedItems)
       }
       cb(responseJson)
      }
    })
  }

}

class Impressum {
  @observable phone
  @observable mail
  @observable company
  @observable street
  @observable zip
  @observable location
  @observable country
  @observable persons

  constructor (impressum) {
    const { phone,mail,company,street,zip,location,country,persons } = impressum
    this.phone = phone ? phone : ""
    this.mail = mail ? mail : ""
    this.company = company ? company : ""
    this.street = street ? street : ""
    this.zip = zip ? zip : ""
    this.location = location ? location : ""
    this.country = country ? country : ""
    this.persons = persons ? persons : ""
  }

  @action.bound setPhone (phone) {
    this.phone = phone
  }
  @action.bound setMail (mail) {
    this.mail = mail
  }
  @action.bound setCompany (company) {
    this.company = company
  }
  @action.bound setStreet (street) {
    this.street = street
  }
  @action.bound setZip (zip) {
    this.zip = zip
  }
  @action.bound setLocation (location) {
    this.location = location
  }
  @action.bound setCountry (country) {
    this.country = country
  }
  @action.bound setPersons (persons) {
    this.persons = persons
  }

  savePhone = (cb) => {
   this.save('/api/impressum/set/phone','POST',{phone:this.phone},cb)
  }

  saveMail = (cb) => {
   this.save('/api/impressum/set/mail','POST',{mail:this.mail},cb)
  }

  saveCompany = (cb) => {
   this.save('/api/impressum/set/company','POST',{company:this.company},cb)
  }

  saveStreet = (cb) => {
   this.save('/api/impressum/set/street','POST',{street:this.street},cb)
  }

  saveZip = (cb) => {
   this.save('/api/impressum/set/zip','POST',{zip:this.zip},cb)
  }

  saveLocation = (cb) => {
   this.save('/api/impressum/set/location','POST',{location:this.location},cb)
  }

  saveCountry = (cb) => {
   this.save('/api/impressum/set/country','POST',{country:this.country},cb)
  }

  savePersons= (cb) => {
   this.save('/api/impressum/set/persons','POST',{persons:this.persons},cb)
  }

  @action save (endpoint, method, body, cb) {
    fetch(route.endpoint + endpoint, {
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (cb) {
       cb(responseJson)
      }
    })
  }
}

class WPSettings {
  @observable logo
  @observable backgroundImage
  @observable title
  @observable subtitle
  @observable description
  @observable enabled

  constructor (wpSettings) {
    const { logo,backgroundimage,title,subtitle,description,enabled } = wpSettings
    this.logo = logo ? logo : ''
    this.backgroundImage = backgroundimage ? backgroundimage : ''
    this.title = title ? title : ''
    this.subtitle = subtitle ? subtitle : ''
    this.description = description ? description : ''
    this.enabled = enabled
  }

  saveTitle = (cb) => {
   this.save('/api/wpsettings/set/title','POST',{title:this.title},cb)
  }
  saveSubtitle = (cb) => {
   this.save('/api/wpsettings/set/subtitle','POST',{subtitle:this.subtitle},cb)
  }
  saveLogo = (cb) => {
   this.save('/api/wpsettings/set/logo','POST',{logo:this.logo},cb)
  }
  saveBackgroundImage = (cb) => {
   this.save('/api/wpsettings/set/backgroundimage','POST',{backgroundImage:this.backgroundImage},cb)
  }
  saveDescription = (cb) => {
   this.save('/api/wpsettings/set/description','POST',{description:this.description},cb)
  }
  saveEnabled = (cb) => {
   this.save('/api/wpsettings/set/enabled','POST',{enabled:this.enabled},cb)
  }

  checkForGoogleDriveImage (url) {
   const match = url.match(/\/d\/(.{25,})\//)
   if (match && match[1]) {
    return 'https://lh3.googleusercontent.com/d/'+match[1]
   }
   return url
  }

  @action.bound setTitle (title) {
    this.title = title
  }
  @action.bound setSubtitle (subtitle) {
    this.subtitle = subtitle
  }
  @action.bound setLogo (logo) {
    this.logo = this.checkForGoogleDriveImage(logo)
  }
  @action.bound setBackgroundImage (bgImg) {
    this.backgroundImage = this.checkForGoogleDriveImage(bgImg)
  }
  @action.bound setDescription (description) {
    this.description = description
  }
  @action.bound setEnabled (checked,cb) {
    this.enabled = checked
    this.saveEnabled(cb)
  }

  @action save (endpoint, method, body, cb) {
    fetch(route.endpoint + endpoint, {
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (cb) {
       cb(responseJson)
      }
    })
  }
}

class Settings {
  @observable collectionimage
  @observable primaryColor
  @observable accentColor
  @observable menuLinkOne
  @observable menuLinkTwo

  constructor (settings) {
    const {collectionimage,primaryColor,accentColor,menuLinkOne,menuLinkTwo} = settings

    this.collectionimage = collectionimage ? collectionimage : ""
    this.primaryColor = primaryColor ? primaryColor : ""
    this.accentColor = accentColor ? accentColor : ""
    this.menuLinkOne = menuLinkOne ? menuLinkOne : {url:"",description:""}
    this.menuLinkTwo = menuLinkTwo ? menuLinkTwo : {url:"",description:""}
  }

  saveMenuLinks = (cb) => {
    if (this.menuLinkOne || this.menuLinkTwo) {
     this.save('/api/settings/set/menulinks','POST',{menuLinkOne:this.menuLinkOne,menuLinkTwo:this.menuLinkTwo},cb)
    }
  }

  savePrimaryColor = (cb) => {
   this.save('/api/settings/set/primarycolor','POST',{primaryColor:this.primaryColor},cb)
  }

  saveAccentColor = (cb) => {
   this.save('/api/settings/set/accentcolor','POST',{accentColor:this.accentColor},cb)
  }

  saveCollectionimage = (cb) => {
    this.save('/api/settings/set/collectionimage','POST',{collectionimage:this.collectionimage},cb)
  }

  @action.bound setMenuLinkOne (link) {
    this.menuLinkOne.url = link
  }

  @action.bound setMenuLinkOneDescription (description) {
    this.menuLinkOne.description = description
  }

  @action.bound setMenuLinkTwo (link) {
    this.menuLinkTwo.url = link
  }

  @action.bound setMenuLinkTwoDescription (description) {
    this.menuLinkTwo.description = description
  }

  @action.bound setPrimaryColor (primaryColor,cb) {
    this.primaryColor = primaryColor
    this.savePrimaryColor(cb)
  }

  @action.bound setAccentColor (accentColor,cb) {
    this.accentColor = accentColor
    this.saveAccentColor(cb)
  }

  @action.bound setCollectionimage (cImage) {
    this.collectionimage = this.checkForGoogleDriveImage(cImage)
  }

  checkForGoogleDriveImage (url) {
   const match = url.match(/\/d\/(.{25,})\//)
   if (match && match[1]) {
    return 'https://lh3.googleusercontent.com/d/'+match[1]
   }
   return url
  }

  @action save (endpoint, method, body, cb) {
    fetch(route.endpoint + endpoint, {
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    .then((response) => response.json())
    .then((responseJson) => {
      if (cb) {
       cb(responseJson)
      }
    })
  }
}

class User {
 id
 login
 created
 mail
 @observable newPassword

 constructor (user) {
   const {id,login,mail,created} = user
   this.id = id
   this.login = login
   this.mail = mail
   this.created = moment(created).format('LL')
 }

 @computed get firstChar () {
   return this.login.charAt(0).toUpperCase()
 }

 @action.bound setNewPassword (password) {
   this.newPassword = password
 }

 @action.bound setMail (mail) {
   this.mail = mail
 }

 @action changePassword (cb) {
   fetch(route.endpoint + '/api/user/changepassword', {
     method: 'POST',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
     body: JSON.stringify({id:this.id,newPassword:this.newPassword})
   })
   .then((response) => response.json())
   .then((responseJson) => {
     this.setNewPassword("")
     cb(responseJson.success)
   })
 }

 @action changeMail (cb) {
   fetch(route.endpoint + '/api/user/changemail', {
     method: 'POST',
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json',
     },
     body: JSON.stringify({id:this.id,mail:this.mail})
   })
   .then((response) => response.json())
   .then((responseJson) => {
     cb(responseJson.success)
   })
 }

}



// WEBPACK FOOTER //
// ./src/stores/storeAdmin.js